export const MY_POINT_LOGS = 'MY_POINT_LOGS';